import { Component, OnInit } from '@angular/core';
import {constants} from '../../constant/constant';
import {FormBuilder, Validators} from '@angular/forms';
import {UserService} from '../../service/user.service';
import {Router} from '@angular/router';
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';
import Swal from "sweetalert2";
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-transport-booking',
  templateUrl: './transport-booking.component.html',
  styleUrls: ['./transport-booking.component.css']
})
export class TransportBookingComponent implements OnInit {
  bookForm: any;
  country = constants.country;
  trans: any;
  constructor(private scrollToService: ScrollToService,private formBuilder: FormBuilder,private userService:UserService,private route :Router, private datePipe: DatePipe) {
    this.trans = JSON.parse(localStorage.getItem('transport'));
    this.bookForm = this.formBuilder.group({
      req: ['',],
      name: ['', Validators.required],
      start: ['', Validators.required],
      end: ['', Validators.required],
      pax: ['', Validators.required],
      email: ['', Validators.required],
      mobile: ['', Validators.required],
      cont: ['', Validators.required],
      package: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.bookForm.controls['package'].setValue(this.trans.name);
    this.triggerScrollTo();
  }

  saveBooking() {
    let  req={
      transportId:this.trans.id,
      customerDTO:{
        id:0,
        clientEmail: this.bookForm.controls.email.value,
        clientName:this.bookForm.controls.name.value,
        country: this.bookForm.controls.cont.value,
        mobileNumber: this.bookForm.controls.mobile.value,
      },
      isTailorMade:0,
      end:this.datePipe.transform(this.bookForm.controls.end.value, 'y-MM-dd'),
      pax:this.bookForm.controls.pax.value,
      start: this.datePipe.transform(this.bookForm.controls.start.value, 'y-MM-dd'),
    }
    this.userService.bookingSave(req).subscribe(
        res => {
          if (res.responseCode == 200) {
            Swal.fire(
                'Booking Success!',
                'session booked successfully',
                'success'
            )
            this.route.navigate(['/index-packages']);
          } else {
            Swal.fire(
                'Booking Faild !',
                'somthing went wrong please try again',
                'error'
            )
          }
        }
    )
  }

  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };

    this.scrollToService.scrollTo(config);
  }
}
